import axios from "axios";
import Configuration from "../config/configuration";


export const ApiRequestMethod = async (payload) => {
  try {
    if (!payload.url) throw new Error("url is required");

    return await axios({
      method: payload.method || "get",
      url: payload.url,
      baseURL: Configuration?.BASEURL,
      timeout: Configuration?.API_TIMEOUT,
      headers: payload.header || Configuration?.API_HEADER,
      data: payload.data,
    });
  } catch (err) {
    if (err.code === "ECONNABORTED") {
      console.error("Request Timeout: The API request took too long to respond.");
      throw new Error("Request Timeout: Please try again later.");
    }
    console.error("API Request Error:", err.message || err);
    throw err;
  }
};
